import React from 'react'
import Layout from 'gatsby-theme-kn/src/components/modules/Layout'
import { useTranslation } from 'react-i18next'
import Image from 'gatsby-theme-kn/src/components/atoms/Image'
import Link from 'gatsby-theme-kn/src/components/atoms/Link'
import Richtext from 'gatsby-theme-kn/src/components/atoms/Richtext'
import OneColWrapper from 'gatsby-theme-kn/src/components/technical/OneColWrapper'
import SEO from 'gatsby-theme-kn/src/components/modules/Seo'

// TODO: fade-in-bottom bei item-grid-block-item

const ProductCategoryPage = ({
  locale,
  content,
  name,
  products,
  alternates,
}) => {
  const { t } = useTranslation()
  console.log(name)
  return (
    <Layout locale={locale} alternates={alternates}>
      <SEO content={content} title={name} />
      <section className="skewed-block skewed-block-on-gray">
        <div className="skewed-block-space"></div>
        <div className="skewed-block-effect"></div>
      </section>

      <section className="item-grid-block">
        <div className="item-grid-block-container">
          <div className="item-grid-block-wrapper">
            <div className="item-grid-block-header">
              <h1>{name}</h1>
              {/* {content.collection_links?.length > 0 &&
                content.collection_links.map((item, index) => (
                  // item.full_slug === @root.full_slug ? <h1>{item.title}</h1> : <span className="h1">{item.title}</span>
                  <h1 key={index}>{item.title}</h1>
                ))} */}
            </div>
            <div className="item-grid-block-body" id="product-filter-wrapper">
              {products?.length > 0 &&
                products.map((item, index) => (
                  <div key={index} className="item-grid-block-item-primary">
                    <Link
                      link={`/${item.full_slug}`}
                      className="item-grid-block-item-content"
                    >
                      <div className="item-grid-block-item-image">
                        <Image
                          className="img-fluid item-grid-block-item-image-big"
                          image={item.content.isolated_image}
                          imageWidth="540"
                          imageHeight="324"
                          fillColor="FFFFFF"
                          alt={`${item.name} - ${item.content.headline}`}
                        />
                      </div>
                      <div className="item-grid-block-item-text">
                        <h4>
                          <span>{item.name}</span>
                        </h4>
                        <p>{item.content.headline}</p>
                      </div>
                      {item.content.main_award?.uploads?.length > 0 &&
                        item.content.main_award.uploads.map((item, index) => (
                          <div
                            className="item-grid-block-item-eyecatcher"
                            key={index}
                          >
                            <div
                              className="item-grid-block-item-eyecatcher-content"
                              style="background-image: url('{{ preview_url }}')"
                            >
                              <span>{item.content.title}</span>
                            </div>
                          </div>
                        ))}
                    </Link>
                  </div>
                ))}
            </div>
          </div>
        </div>
      </section>
      <section
        className="product-category-description-block"
        style={{ background: '#f6f6f6' }}
      >
        <OneColWrapper block={{}}>
          <Richtext text={content.product_category_description} />
        </OneColWrapper>
      </section>
    </Layout>
  )
}

export default ProductCategoryPage
